import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import { Page404Component } from './views/pages/page404/page404.component';
import { Page500Component } from './views/pages/page500/page500.component';
import { LoginComponent } from './views/pages/login/login.component';
import { RegisterComponent } from './views/pages/register/register.component';
import { AuthGuard } from './helpers';
import {ForgotPasswordComponent} from "@app/views/pages/forgot-password/forgot-password.component";
import {UpdatePasswordComponent} from "@app/views/pages/update-password/update-password.component";
import {NotificationComponent} from "@app/views/pages/notification/notification.component";
import { AccountComponent } from "@app/views/pages/account/account.component";
import {NonAccountComponent} from "@app/views/pages/non-account/non-account.component";
import {PaymentComponent} from "@app/views/pages/payment/payment.component";
import {PurchaseComponent} from "@app/views/pages/purchase/purchase.component";
import {PaymentMethodComponent} from "@app/views/pages/payment-methods/payment-method.component";

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: AccountComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'theme',
        loadChildren: () =>
          import('./views/theme/theme.module').then((m) => m.ThemeModule)
      },
      {
        path: 'base',
        loadChildren: () =>
          import('./views/base/base.module').then((m) => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () =>
          import('./views/buttons/buttons.module').then((m) => m.ButtonsModule)
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./views/forms/forms.module').then((m) => m.CoreUIFormsModule)
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./views/charts/charts.module').then((m) => m.ChartsModule)
      },
      {
        path: 'icons',
        loadChildren: () =>
          import('./views/icons/icons.module').then((m) => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./views/notifications/notifications.module').then((m) => m.NotificationsModule)
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./views/widgets/widgets.module').then((m) => m.WidgetsModule)
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./views/pages/pages.module').then((m) => m.PagesModule)
      },
    ]
  },
  {
    path: '404',
    component: Page404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: Page500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: {
      title: 'Forgot password Page'
    }
  },
  {
    path: 'update-password',
    canActivate: [AuthGuard],
    component: UpdatePasswordComponent,
    data: {
      title: 'Update password Page'
    }
  },
  {
    path: 'notification',
    canActivate: [AuthGuard],
    component: NotificationComponent,
    data: {
      title: 'Notification Page',
    }
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    component: AccountComponent,
    data: {
      title: 'Account Page'
    }
  },
  {
    path: 'non-account',
    component: NonAccountComponent,
    data: {
      title: 'Non-account Page'
    }
  },
  {
    canActivate: [AuthGuard],
    path: 'payment',
    component: PaymentComponent,
    data: {
      title: 'Payment Page'
    }
  },
  {
    canActivate: [AuthGuard],
    path: 'payment-method',
    component: PaymentMethodComponent,
    data: {
      title: 'Payment method'
    }
  },
  {
    path: 'purchase',
    canActivate: [AuthGuard],
    component: PurchaseComponent,
    data: {
      title: 'Purchase Page'
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
